<template>

  <div class="item_main">

    <div class="title">1.词库选择</div>
    <div class="content">选择需要背诵的词书，进入“计划设置” 页面，选择每日新词或总天数、复习周期、记忆顺序后，可查看学习计划表，点击“开启单词记忆之旅”，进入背单词页面。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/choosebook.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>
    
    <div class="title">2.背单词页面介绍</div>
    <div class="content">
      背单词页面如下图所示，中间主体部分为单词列表，顶部菜单主要包括设置、当前背诵list,打卡按钮及查词按钮；底部菜单主要包括新学和需要复习的list、更多菜单及学习计划表。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/homepage.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="second_title">2.1 单词左侧不同颜色意义</div>
    <div class="content">
      左侧不同颜色代表背诵词数及熟练程度，颜色越深，背诵词数越多，越熟练，反之，颜色越浅，背诵词数较少，单词较陌生。
  
    </div>
    <div class="second_title">2.2 单词右滑菜单</div>
    
    <div class="content">
      单词右滑有三个按钮，分别是标记-1、编辑、加入生词（移除生词），标记-1按钮可将单词左侧颜色变浅，陌生程度增加；编辑按钮可自定义单词释义；加入生词（移除生词）按钮可将单词加入生词本或移除生词本。
  
    </div>
    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/leftmenu.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>
    <div class="second_title">2.3 单词左滑菜单</div>
    
    <div class="content">
      单词左滑有一个按钮，可将单词加入熟知，加入熟知后，将不会显示再列表中，可在单词本熟知词中查看。
  
    </div>
    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/rightmenu.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>
    <div class="second_title">2.4 长按查词</div>
    
    <div class="content">
      长按单词，可弹出查词窗口。
      
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/chaci.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>
    

    <div class="title">3.显示及排序</div>
    <div class="content">
      显示方式包括中英显示、遮罩中文、遮罩英文。排序方式包括原序、正序、随机、熟练度。

  
    </div>
    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/menu.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>
    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/showchi.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>
    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/showeng.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>


    <div class="title">4.学习计划表</div>
    <div class="content">
      每天的学习内容由当前记忆和过往复习两部分组成，当前day的记忆及复习全部打卡完成，方可进入下一天的学习。

  
    </div>
    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/plan.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    
    
  </div>

  

  
 



  
  

  
    
  </template>
  
  <script setup>

  </script>
  
  <style scoped>

  .item_main {
    font-size: 0.4rem;
    margin-left: 0.4rem;
    margin-right: 0.4rem;
    text-align: left;
  }

  .title {
    font-size: 0.45rem;
    font-weight: bold;
    margin-top: 0.4rem;
    margin-bottom: 0.2rem;
  }
  .second_title {
    font-size: 0.42rem;
    
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  .content {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  .image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  

 

  
  
  </style>